import type { IHealthServiceProvider } from '#domain/health';
import { defineStore } from 'pinia';
import { useInject } from '../core/utils/useInject';

export const useHealthStore = defineStore('health', {
  state: () => ({
    message: '',
    statusCode: -1
  }),
  actions: {
    async fetchHealthStatus() {
      try {
        const healthServiceProvider = useInject<IHealthServiceProvider>('healthServiceProvider');
        const response = await healthServiceProvider.getHealthStatus();
        this.message = response.message;
        this.statusCode = response.statusCode;
      } catch {
        this.message = 'unhealthy';
        this.statusCode = 0;
      }
    }
  }
});
